import { render } from "./SecurityCenter.vue?vue&type=template&id=b4c6310c&scoped=true"
import script from "./SecurityCenter.vue?vue&type=script&lang=js"
export * from "./SecurityCenter.vue?vue&type=script&lang=js"

import "./SecurityCenter.vue?vue&type=style&index=0&id=b4c6310c&lang=scss&scoped=true"

import exportComponent from "D:\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4c6310c"]])

export default __exports__